import { isAvailable, FDealType, FOfferType } from '../../../../../packages/JsonQuery';
import { IFilterSet, TFilter } from 'shared/types/filters';

export const OTHER_FILTERS_SET: IFilterSet<TFilter>[] = [
  {
    availability: isAvailable(FDealType.Any, FOfferType.Other),
    list: ['dealType', 'offerType', 'price', 'advancedFilters', 'geo'],
  },
];
